import React from 'react'

const MyDevice = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="28"
            height="28"
            viewBox="0 0 72 72"
        >
            <g
                id="Group_98"
                data-name="Group 98"
                transform="translate(-8350 -3938)"
            >
                <rect
                    id="Rectangle_155"
                    data-name="Rectangle 155"
                    width="72"
                    height="72"
                    transform="translate(8350 3938)"
                    opacity="0"
                />
                <g
                    id="Group_102"
                    data-name="Group 102"
                    transform="translate(7358.375 3998.785)"
                >
                    <g
                        id="Group_99"
                        data-name="Group 99"
                        transform="translate(1011.996 -56.627)"
                    >
                        <path
                            id="Path_4705"
                            data-name="Path 4705"
                            d="M1070.023-13.684c-2.385-6.269-4.722-9.123-7.035-17.022-.623-3.1-.833-3.582-.742-5.3.253-4.852,2.9-5.117,5.45-6.011,1.853-.65,1.535-1.537.845-2.217,0,0-.005-.005-.007-.007a6.613,6.613,0,0,0-1.439-1l-.005,0-.016-.009a16.632,16.632,0,0,0-4.736-1.674.38.38,0,0,1-.25-.568,5.941,5.941,0,0,0,.9-3.156,5.974,5.974,0,0,0-5.846-5.973,5.974,5.974,0,0,0-5.846,5.973,5.939,5.939,0,0,0,.9,3.156.379.379,0,0,1-.25.568,16.673,16.673,0,0,0-4.736,1.674l-.016.009-.005,0a6.613,6.613,0,0,0-1.439,1s0,.005-.007.007c-.69.681-1.008,1.567.845,2.217,2.548.894,5.2,1.158,5.45,6.011.09,1.718-.12,2.2-.742,5.3-2.118,8.49-4.65,10.752-7.033,17.022-2.545,6.68-3.911,11.9-.181,15.4a.5.5,0,0,1,.156.393c-.014.243.083.648.76.939a4.942,4.942,0,0,1,1.689,1.908,2.528,2.528,0,0,0,1.482,1.146,26.06,26.06,0,0,0,7.058.956v0h.174l3.033-.007q.3.005.6.005c.25,0,.494,0,.735-.009h.06v0a25.812,25.812,0,0,0,6.291-.945,2.54,2.54,0,0,0,1.482-1.146,4.923,4.923,0,0,1,1.687-1.908c.677-.291.775-.7.762-.939a.5.5,0,0,1,.154-.393C1073.933-1.784,1072.568-7,1070.023-13.684Zm-1.3,13.813a2.656,2.656,0,0,0-.72,1.144,7.08,7.08,0,0,0-2.268,2.577.372.372,0,0,1-.215.163,23.7,23.7,0,0,1-5.752.86l-.058,0c-.223.007-.449.009-.673.009-.183,0-.367,0-.55-.005h-.053l-2.8.007-.4,0a23.882,23.882,0,0,1-6.461-.871.362.362,0,0,1-.214-.163,7.1,7.1,0,0,0-2.27-2.577,2.651,2.651,0,0,0-.719-1.144c-1.452-1.361-1.888-3.1-1.457-5.828a41.984,41.984,0,0,1,2.476-7.985c.309-.8.558-1.657.968-2.47,2.369-4.7,4.822-6.778,5.882-14.184.623-3.115.874-3.79.771-5.781A8.023,8.023,0,0,0,1052-41.79a8.436,8.436,0,0,0-3.272-1.81,15.522,15.522,0,0,1,3.665-1.2,2.547,2.547,0,0,0,1.83-1.5,2.544,2.544,0,0,0-.179-2.347,3.782,3.782,0,0,1-.572-2.007,3.823,3.823,0,0,1,3.674-3.8,3.823,3.823,0,0,1,3.674,3.8,3.782,3.782,0,0,1-.572,2.007,2.544,2.544,0,0,0-.179,2.347,2.55,2.55,0,0,0,1.832,1.5,15.547,15.547,0,0,1,3.665,1.2,8.436,8.436,0,0,0-3.272,1.81,8.017,8.017,0,0,0-2.212,5.67c-.1,1.991.147,2.664.769,5.781,1.06,7.406,3.89,10.125,5.882,14.184.4.818.659,1.672.968,2.47a41.849,41.849,0,0,1,2.476,7.985C1070.6-2.975,1070.17-1.232,1068.718.129Z"
                            transform="translate(-1041.785 56.627)"
                        />
                        <path
                            id="Path_4706"
                            data-name="Path 4706"
                            d="M1085.557,199.932a2.267,2.267,0,0,0-.466.616,1.766,1.766,0,0,1-.482.59,6.824,6.824,0,0,0-1.6,1.972.318.318,0,0,1-.184.139,20.231,20.231,0,0,1-4.912.734l-.049,0c-.19.006-.383.008-.575.008-.156,0-.313,0-.47,0h-.045l-2.391.006h-.34a20.391,20.391,0,0,1-5.518-.743.309.309,0,0,1-.182-.139,6.854,6.854,0,0,0-1.6-1.972,1.77,1.77,0,0,1-.483-.593,2.256,2.256,0,0,0-.464-.613c-1.24-1.162-1.612-2.651-1.244-4.977a30.311,30.311,0,0,1,1.636-5.563,1.93,1.93,0,0,1,1.807-1.256h15.371a1.93,1.93,0,0,1,1.807,1.256,30.183,30.183,0,0,1,1.636,5.563C1087.168,197.281,1086.8,198.769,1085.557,199.932Z"
                            transform="translate(-1060.314 -143.837)"
                        />
                    </g>
                    <g
                        id="Group_100"
                        data-name="Group 100"
                        transform="translate(1034.968 -46.036)"
                    >
                        <path
                            id="Path_4707"
                            data-name="Path 4707"
                            d="M1168.727,98.485l.841,2.4a.317.317,0,0,0,.584.034l.741-1.526a.317.317,0,0,0-.121-.409l-1.554-.941a.317.317,0,0,0-.455.146l-.029.067A.317.317,0,0,0,1168.727,98.485Z"
                            transform="translate(-1168.709 -80.603)"
                        />
                        <path
                            id="Path_4708"
                            data-name="Path 4708"
                            d="M1169.336,80.967l2.154,1.335a.344.344,0,0,0,.327.019l.122-.057a.344.344,0,0,0,.161-.155l1.394-2.726a.344.344,0,0,0-.148-.462l-2.258-1.173a.344.344,0,0,0-.462.142l-1.412,2.621a.325.325,0,0,0-.021.049h0A.344.344,0,0,0,1169.336,80.967Z"
                            transform="translate(-1169.089 -63.988)"
                        />
                        <path
                            id="Path_4709"
                            data-name="Path 4709"
                            d="M1181.621,15.658l1.492.731a.416.416,0,0,0,.555-.187l4.712-9.417.01-.02,1.6-3.692a.415.415,0,0,0-.171-.524l-1.024-.6a.416.416,0,0,0-.575.161l-1.875,3.465-4.91,9.519A.415.415,0,0,0,1181.621,15.658Z"
                            transform="translate(-1179.094 -1.893)"
                        />
                    </g>
                    <path
                        id="Path_4710"
                        data-name="Path 4710"
                        d="M1011.137,245.838c-1.161-.081-4.961-.227-5.682,1.268a.442.442,0,0,0-.041.206c.059,1.744,2.052,2.357,6.734,2.139a.485.485,0,0,0,.394-.734,10.033,10.033,0,0,1-.7-1.317.483.483,0,0,0-.406-.306l-3.5-.324s1.987-.034,3.132.035a.484.484,0,0,0,.495-.619h0A.483.483,0,0,0,1011.137,245.838Z"
                        transform="translate(0 -247.685)"
                    />
                    <g
                        id="Group_101"
                        data-name="Group 101"
                        transform="translate(1038.046 -26.738)"
                    >
                        <path
                            id="Path_4711"
                            data-name="Path 4711"
                            d="M1185.751,133.241l.836,2.07a.477.477,0,0,0,.785.153l1.04-1.077a.477.477,0,0,0,.007-.656l-1.386-1.5a.477.477,0,0,0-.691-.009l-.49.5A.476.476,0,0,0,1185.751,133.241Z"
                            transform="translate(-1185.717 -127.818)"
                        />
                        <path
                            id="Path_4712"
                            data-name="Path 4712"
                            d="M1195.023,113.2l.26.3a1.159,1.159,0,0,0,1.717.029c.924-.988,2.154-2.392,3.472-2.33,2.484.115,3.954,6.79-1.584,16.179a.477.477,0,0,0-.041.4l.64,1.856a.477.477,0,0,0,.843.117,25.64,25.64,0,0,0,4.373-17.3,1.279,1.279,0,0,0-.047-.213c-2.14-6.785-7.531-2.553-9.559-.636A1.159,1.159,0,0,0,1195.023,113.2Z"
                            transform="translate(-1193.102 -108.519)"
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default React.memo(MyDevice)
